/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Quick_AddInputs */

const en_link_editor_quick_add = /** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Link`)
};

const es_link_editor_quick_add = /** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlace Personalizado`)
};

const fr_link_editor_quick_add = /** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien personnalisé`)
};

const de_link_editor_quick_add = /** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierter Link`)
};

/** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */
const ja_link_editor_quick_add = en_link_editor_quick_add;

/** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */
const zh_link_editor_quick_add = en_link_editor_quick_add;

/** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */
const ar_link_editor_quick_add = en_link_editor_quick_add;

/** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */
const id_link_editor_quick_add = en_link_editor_quick_add;

/** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */
const it_link_editor_quick_add = en_link_editor_quick_add;

/** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */
const ru_link_editor_quick_add = en_link_editor_quick_add;

/** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */
const pt_link_editor_quick_add = en_link_editor_quick_add;

/** @type {(inputs: Link_Editor_Quick_AddInputs) => LocalizedString} */
const ko_link_editor_quick_add = en_link_editor_quick_add;

/**
* | output |
* | --- |
* | "Custom Link" |
*
* @param {Link_Editor_Quick_AddInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_quick_add = /** @type {((inputs?: Link_Editor_Quick_AddInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Quick_AddInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_quick_add(inputs)
	if (locale === "es") return es_link_editor_quick_add(inputs)
	if (locale === "fr") return fr_link_editor_quick_add(inputs)
	if (locale === "de") return de_link_editor_quick_add(inputs)
	if (locale === "ja") return ja_link_editor_quick_add(inputs)
	if (locale === "zh") return zh_link_editor_quick_add(inputs)
	if (locale === "ar") return ar_link_editor_quick_add(inputs)
	if (locale === "id") return id_link_editor_quick_add(inputs)
	if (locale === "it") return it_link_editor_quick_add(inputs)
	if (locale === "ru") return ru_link_editor_quick_add(inputs)
	if (locale === "pt") return pt_link_editor_quick_add(inputs)
	return ko_link_editor_quick_add(inputs)
});